// BottomAgeVerifyBanner.js
'use strict';
import { connect } from 'react-redux';
import getMeData from '../selector/getMeData.js';
import addModal from '../action/addModal.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { PREVIEW_PRESET, TRAILER_BLOCKER_URL } from '../RemoteConfigKeys.js';
import login from '../action/login.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';

import BottomAgeVerifyBanner from '../component/BottomAgeVerifyBanner.jsx';
const mapStateToProps = state => {
  const token = getMeData(state, 'token');
  return {
    isAuthed: !!getMeData(state, 'id'),
    blockerUrl: getRemoteConfigData(state, TRAILER_BLOCKER_URL),
    shouldAgeVerify: getRemoteConfigData(state, PREVIEW_PRESET) === 'blurred',
    isRemoteConfigMerged: token
      ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
      : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
        getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    openVerifyFreeUserModal: () =>
      dispatch(addModal({ id: 'VerifyFreeUserModal', isHigherThanAll: true })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BottomAgeVerifyBanner);
